import { Tag } from "antd";
import React from "react";

const CustomTag = ({ text, color }) => {
  return <Tag color={color}>{text}</Tag>;
};

export default CustomTag;
